<template>
    <transition name="fade">
        <div class="modal-overlay" v-if="visible" @click.self="handleCancel">
            <div class="modal">
                <div class="modal-header">
                    <h1 class="modal-title">{{ title }}</h1>
                    <button class="close-button" @click="handleCancel">
                        <font-awesome-icon icon="xmark" />
                    </button>
                </div>

                <div class="modal-content">
                    <p class="confirm-message">{{ message }}</p>

                    <div class="modal-actions">
                        <button type="button" class="cancel-button" @click="handleCancel">
                            {{ cancelText }}
                        </button>
                        <button type="button" :class="['save-button', { 'danger-button': danger }]"
                            @click="handleConfirm">
                            {{ confirmText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Potwierdzenie'
        },
        message: {
            type: String,
            default: 'Czy na pewno chcesz kontynuować?'
        },
        confirmText: {
            type: String,
            default: 'Tak'
        },
        cancelText: {
            type: String,
            default: 'Anuluj'
        },
        danger: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleConfirm() {
            this.$emit('confirm')
            this.$emit('close')
        },
        handleCancel() {
            this.$emit('cancel')
            this.$emit('close')
        }
    }
}
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
}

.modal {
    width: 100%;
    max-width: 500px;
    background-color: $color-background;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 16px 20px;
    background-color: $color-primary;
    color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
}

.close-button {
    background: none;
    border: none;
    color: $color-white;
    font-size: 1.3rem;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.modal-content {
    padding: 20px;
}

.confirm-message {
    margin: 0 0 20px 0;
    font-size: 1rem;
    color: $color-text;
    line-height: 1.5;
}

.modal-actions {
    display: flex;
    gap: 1rem;
    margin-top: 20px;

    button {
        flex: 1;
        padding: 10px 16px;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .save-button {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }

        &.danger-button {
            background-color: $color-primary-accent;

            &:hover {
                background-color: darken($color-primary-accent, 8%);
            }
        }
    }

    .cancel-button {
        background-color: $color-grey;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }
}

@media (max-width: 600px) {
    .modal-actions {
        flex-direction: column;

        button {
            width: 100%;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
